import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import GroupSelector from "./GroupSelector";
import GroupTable from "./GroupTable";
import PaginationControls from "../components/PaginationControls";
import { useGroupHandlers } from "../hooks/useGroupHandlers";

const Groups = ({ groups, sendTableDataToParent, setError, examid }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [apiGroups, setApiGroups] = useState([]);
  const rowsPerPage = 10;

  const {
    handleAddGroups,
    handleDelete,
    handleUndo,
    currentRows,
    totalPages,
    handlePageChange,
    renderPageNumbers
  } = useGroupHandlers({
    groups,
    sendTableDataToParent,
    setError,
    examid,
    searchTerm,
    page,
    setPage,
    selectedGroups,
    setSelectedGroups,
    setApiGroups,
    rowsPerPage
  });

  useEffect(() => {
    setPage(1);
  }, [searchTerm, groups]);

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>Groups</Typography>

      <GroupSelector
        apiGroups={apiGroups}
        selectedGroups={selectedGroups}
        setSelectedGroups={setSelectedGroups}
        handleAddGroups={handleAddGroups}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />

      <GroupTable
        currentRows={currentRows}
        page={page}
        rowsPerPage={rowsPerPage}
        onDelete={handleDelete}
        onUndo={handleUndo}
      />

      {totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 4, gap: 1 }}>
          <PaginationControls
            page={page}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            renderPageNumbers={renderPageNumbers}
          />
        </Box>
      )}
    </Box>
  );
};

export default Groups;
